import namespace from './namespace';

export default {
	[namespace.mutations.ADD_NOTIFICATION] (state, payload) {
		if (payload.receiver === 'AppConfig') {
			handleAppConfigNotification(state, payload);
		} else if (payload.receiver === 'CookieStore') {
			handleCookieStoreSetUp(state, payload);
		} else {
			state[namespace.state.NOTIFICATIONS] = payload;
		}
	},
	[namespace.mutations.ASSIGN_LISTENER] (state, payload) {
		state[namespace.state.NOTIFICATIONS_LISTENERS][payload.on] = payload.handler;
	}
};

const handleAppConfigNotification = function(state, notification) {
	if (notification.payload.contextPath !== undefined) {
		state[namespace.state.CONFIG]['contextPath'] = notification.payload.contextPath;
	}
};

const handleCookieStoreSetUp = function(state, notificationPayload) {
	state[namespace.state.COOKIE_STORE] = notificationPayload.payload.cookieStore;
}


// WEBPACK FOOTER //
// ./src/store/modules/app/mutations.js